
<template lang="pug">
form.cnmn-form(@submit.prevent="onFormSubmit")
  slot(:disableSubmit="disableSubmit")

  //- 確認画面
  slot(
    v-if="confirm"
    name="confirm"
    :submit="onConfirmSubmit"
    :cancel="onConfirmCancel"
  )
    cnmn-modal
      cnmn-confirm(
        :model="model"
        @submit="onConfirmSubmit"
        @cancel="onConfirmCancel"
      )

  //- reCaptcha
  vue-recaptcha-ex(
    ref="recaptcha"
    :badge="recaptchaBadge"
    :sitekey="recaptchaSiteKey"
    @verify="onRecaptchaVerify"
    @error="onRecaptchaError"
  )
</template>

<script>
import axios from 'axios'

import {vueFindProgeny} from '@/helpers/vue-component-inspect'
import VueRecaptchaEx from '@/components/vue-recaptcha-ex'

export default {
  components: {VueRecaptchaEx},

  provide() {
    return {
      setFormState:    this.setFormState,
      queryFormState:  this.queryFormState,
      deleteFormState: this.deleteFormState,
    }
  },

  props: {
    action: {type: String, required: true},
    method: String,
    successUrl: String,
    model: {type: Object, required: true},

    //- reCaptcha
    recaptchaBadge: String,
    recaptchaSiteKey: String,
  },

  data() {
    return {

      //- ステート
      state: {},

      //- 確認画面
      confirm: false,
      clearSubmittingCB: null,
    }
  },

  computed: {

    //- バリデーション
    disableSubmit() {
      return Object.values(this.state).map(({errors}) => errors || []).flat().length !== 0
    },
  },

  methods: {
    onFormSubmit(ev) {
      this.touchAllFields()
      if(!this.disableSubmit) {
        this.confirm = true
      }
    },

    //- ステート
    setFormState(key, state) {
      this.state = {...this.state, [key]: {...this.state[key], ...state}}
    },

    queryFormState(key) {
      return this.state[key] === undefined ? {} : this.state[key]
    },

    deleteFormState(key) {
      const {[key]: _, ...state} = this.state
      this.state = state
    },

    //- バリデーション
    touchAllFields() {
      for(const {field} of Object.values(this.state)) {
        if(field) {
          field.touch()
        }
      }
    },

    //- 確認画面
    onConfirmSubmit({clearSubmitting}) {
      this.clearSubmittingCB = clearSubmitting
      this.$refs.recaptcha.execute()
    },

    clearSubmitting() {
      if(this.clearSubmittingCB) {
        this.clearSubmittingCB()
        this.clearSubmittingCB = null
      }
    },

    onConfirmCancel() {
      this.confirm = false
    },

    //- reCaptcha
    async onRecaptchaVerify(response) {
      try {
        const {data} = await axios.post(
          this.action,
          {
            ...this.model,
            ...response,
          },
          {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        )

        if(data.success) {
          console.log('cnmn-form: submit successfully', data)
          this.confirm = false
          this.$refs.recaptcha.reset()
          this.$emit('success')
          if(this.successUrl) {
             window.location.href = this.successUrl
          }
        }
        else {
          console.warn('cnmn-form: reCAPTCHA verify error', data)
          this.$cnmn.notify.error('通信エラーです')
        }
      }
      catch(e) {
        console.warn('cnmn-form: network error', e)
        this.$cnmn.notify.error('通信エラーです')
      }
      this.clearSubmitting()
    },

    onRecaptchaError(e) {
      console.warn('cnmn-form: reCAPTCHA error', e)
      this.$cnmn.notify.error('通信エラーです')
      this.clearSubmitting()
    },
  },
}
</script>

<style lang="sass">
.cnmn-form-popup
  background-color: rgba(0, 0, 0, .5)
  bottom: 0
  display: flex
  justify-content: center
  left: 0
  position: fixed
  right: 0
  top: 0
  z-index: 10000

.cnmn-form-popup__container
  background-color: white
  border-radius: 8px
  display: flex
  flex-direction: column
  margin: 10px
  padding: 20px
</style>
